import React, { Component } from "react";
import {
    Row,
    Col,
    CustomInput,
    Progress,
    Dropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem,
} from "reactstrap";
import {
    AvForm,
    AvField,
    AvGroup,
    AvInput,
    AvFeedback,
    AvCheckbox,
    AvCheckboxGroup,
    AvRadioGroup,
    AvRadio,
} from "availity-reactstrap-validation";
import Form from "react-bootstrap/Form";

import HighlightOffIcon from "@material-ui/icons/HighlightOff";
import PublishIcon from "@material-ui/icons/Publish";
import { toAbsoluteUrl } from "../../../_metronic/index.js";
import Pagination from "react-js-pagination";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import { Button, Drawer } from "@material-ui/core";
import { translations } from "../../../translate.js";
import { Picky } from "react-picky";
import "react-picky/dist/picky.css";
import EmailIcon from "@material-ui/icons/Email";
import CircularProgress from "@material-ui/core/CircularProgress";
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";
import Tooltip from "rc-tooltip";
import "rc-tooltip/assets/bootstrap.css";

let Strings =
    localStorage.getItem("LANG") == 1 ? translations.Ar : translations.En;
var today = new Date();
var currentDate =
    today.getFullYear() +
    "-" +
    ("0" + (today.getMonth() + 1)).slice(-2) +
    "-" +
    ("0" + today.getDate()).slice(-2);
class PointProfit extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: 0,
            data: [],
            limit: 25,
            activePage: 1,
            dateFrom: currentDate,
            dateTo: currentDate,
            total: 0,
            additionTotal: 0,
            withdrawalTotal: 0,
            orderTotal: 0,
            emptyEmail: 0,
            loadingSave: 0,
            dataCount: 0,
            posId: '8347',
            // this.state.data,
            posName: "",
            //  this.state.data["fname"] + " " + this.state.data["lname"],

            errorMsg: "",
            note1: "",
            totalFilter: 0,
            additionPOSTotal: 0,
            withdrawalPOSTotal: 0,
            note2: "",
            pos_mgr_emp: localStorage.getItem("USER_TYPE") == 7 ? 1 : 0,
            colDate: localStorage.getItem("USER_TYPE") == 7 ? 1 : 2,
            types_operation_list: [],
            selected_types_operation_list: [],
            note1Title: Strings["Note"] + " 1",
            note2Title: Strings["Note"] + " 2",
            posManagerName: "",
            loadingTips: 0,
            transId: "",
            typesOps: 0,
            paymentTypeKey: "",
            paymentTypes: [],
            cardsProfitData: [],
            cardsProfitLoading: 0,
            cardsProfitErrorMsg: "",
            cardsProfitTotal: 0,
            filterMode: 7,
            posData: {},
        };
    }
    handleRefresh = () => {
        // clear all filter data
        this.setState(
            {
                loading: 0,
                activePage: 1,
                dateFrom: currentDate,
                dateTo: currentDate,
                total: 0,
                additionTotal: 0,
                withdrawalTotal: 0,
                orderTotal: 0,
                dataCount: 0,
                visibleid: "",
                data: [],
                typesOps: 0,
                selected_types_operation_list: [],
                errorMsg: "",
            },
            function () {
                this.getCardsProfitInventoryReport();
            }
        );
    };

    componentDidMount() {

        document.addEventListener("mousedown", this.handleClickOutside);
        this.getUserInfoPOS();
        this.getCardsProfitInventoryReport();

        // this.getFinancialReport();
    }






    handleInputChange = (event) => {
        const target = event.target;
        const name = target.name;
        const value = target.type === "checkbox" ? target.checked : target.value;
        if (name == "email") {
            this.setState({
                [name]: value,
                emptyEmail: 0,
            });
        } else {
            this.setState(
                {
                    [name]: value,
                    activePage: 1,
                },
                function () {
                    this.getCardsProfitInventoryReport();
                }
            );
        }
    };
    exportHandler() {
        if (this.state.posId != 0) {
            window.location =
                window.API_PERM_USER +
                "/permUser.php?type=" +
                "cardsProfitInventoryReport_v3" +
                "&lang=" +
                localStorage.getItem("LANG") +
                "&userId=" +
                localStorage.getItem("USER_ID") +
                "&token=" +
                localStorage.getItem("USER_TOKEN") +
                "&orderFilterDateFrom=" +
                this.state.dateFrom +
                "&orderFilterDateTo=" +
                this.state.dateTo +
                "&posId=" +
                this.state.posId +
                "&filterMode=" +
                this.state.filterMode +
                "&export=1";
        }
    }
    handleChangeSelect = (type, option) => {
        this.setState(
            (state) => {
                return {
                    [type]: option,
                    activePage: 1,
                };
            },
            function () {
                if (type == "selected_types_operation_list") {
                    this.setState(
                        {
                            typesOps: option.typeId,
                            paymentTypeKey: option.typeId == 3 ? 1 : "",
                        },
                        function () {
                            this.getFinancialReport();
                        }
                    );
                }
            }
        );
    };
    handlePageChange = (pageNumber) => {
        this.setState({ activePage: pageNumber }, function () {
            this.getCardsProfitInventoryReport();
        });
    };

    handleClickOutside = (event) => {
        if (event.target.className != undefined) {
            if (!event.target.classList.contains("actionDropdownList")) {
                this.setState({
                    openHeader: "",
                    visibleid: "",
                });
            }
        }
    };
    onVisibleChange = (visible, id, type, posId, typeId) => {
        this.setState(
            {
                [type]: id,
                posManagerName: "",
                transId: "",
                loadingTips: 1,
            },
            function () {
                this.getTransInfo(posId, typeId);
            }
        );
    };
    getCardsProfitInventoryReport = () => {
        this.setState({ cardsProfitLoading: 1 });
        fetch(window.API_PERM_USER, {
            method: "POST",
            body: JSON.stringify({
                type: "cardsProfitInventoryReport_v3",
                lang: localStorage.getItem("LANG"),
                userId: localStorage.getItem("USER_ID"),
                token: localStorage.getItem("USER_TOKEN"),
                orderFilterDateFrom: this.state.dateFrom,
                orderFilterDateTo: this.state.dateTo,
                filterMode: this.state.filterMode,
                posId: this.state.posData.userId,
                page: this.state.activePage,
                limit: this.state.limit
            }),
            headers: {
                Accept: "application/json",
            },
        })
            .then(function (response) {
                return response.json();
            })
            .then((data) => {
                if (data !== "Nothing found") {
                    if (data["logout"] == 1) {
                        localStorage.setItem("USER_ID", "");
                        localStorage.setItem("USER_TOKEN", "");
                        window.location.href = "/logout";
                    } else if (data["error"] == 1) {
                        this.setState({
                            cardsProfitLoading: 0,
                            cardsProfitErrorMsg: data["errorMsg"],
                            data: []
                        });
                    } else {
                        this.setState({
                            data: data["reportInfo"],
                            cardsProfitTotal: data["Totals"],
                            cardsProfitLoading: 0,
                            dataCount: data["count"],
                            cardsProfitErrorMsg: ""
                        });
                    }
                    // console.log("cardsProfitData", this.state.cardsProfitTotal.Profit);

                }
            })
            .catch(error => {
                this.setState({
                    cardsProfitLoading: 0,
                    // cardsProfitErrorMsg: Strings["An error occurred while fetching data"]
                });
            });
    };
    getUserInfoPOS = () => {
        this.setState({ cardsProfitLoading: 1 });

        fetch(window.API_PERM_USER, {
            method: "POST",
            body: JSON.stringify({
                type: "getUserInfoPOS",
                lang: localStorage.getItem("LANG"),
                userId: localStorage.getItem("USER_ID"),
                token: localStorage.getItem("USER_TOKEN")
            }),
            headers: {
                Accept: "application/json",
            },
        })
            .then(function (response) {
                return response.json();
            })
            .then((data) => {
                console.log("data", data);
                if (data !== "Nothing found") {
                    if (data["logout"] == 1) {
                        localStorage.setItem("USER_ID", "");
                        localStorage.setItem("USER_TOKEN", "");
                        // window.location.href = "/logout";
                    } else {
                        this.setState({
                            posId: data["userId"],
                            posData: data,
                            cardsProfitLoading: 0,
                            cardsProfitErrorMsg: ""
                        });
                    }
                }
                console.log("this.state.posData", this.state.posData);

            });
    };
    render() {
        // console.log(this.state.data, "this.state.data");

        let dataInfo = [];
        var typeNmae = "";
        var correctName = "";
        var col = this.state.typesOps == 3 ? 2 : 1;
        var type = "";
        var note1 = "";
        var note2 = "";
        var balBefore = "";
        var balAfter = "";
        var classStyle = {
            "text-1": "succ-color",
            "text-2": "warning-color",
            "text-3": "reject-color",
            "text-5": "addCredit-color",
            "text-6": "wthdrawal-color",
        };
        var classColStatus = "";
        if (this.state.loading == 0
            && this.state.data.length > 0
        ) {
            this.state.data.map((rowData, index) => {
                type = rowData["type"];
                if (type !== "") {
                    classColStatus = classStyle["text-" + type];
                }
                classColStatus = "  bold-font " + classColStatus + " "; //overflow-text-length
                dataInfo.push(
                    <Row key={rowData.id} className="table-body-row">
                        <Col
                            lg={3}
                            md={3}
                            sm={3}
                            xs={12}
                            className="overflow-text-length"
                            title={rowData["cardNameAr"]}
                        >
                            {localStorage.getItem("LANG") == 1
                                ? rowData["cardNameAr"]
                                : rowData["cardNameEn"]}
                        </Col>
                        <Col
                            lg={1}
                            md={1}
                            sm={1}
                            xs={12}
                            className="overflow-text-length"
                            title={rowData["classId"]}
                        >
                            {rowData["classId"]}
                        </Col>
                        <Col
                            lg={2}
                            md={2}
                            sm={2}
                            xs={12}
                            className="overflow-text-length"
                            title={localStorage.getItem("LANG") == 1
                                ? rowData["className"]
                                : rowData["className_en"]}
                        >
                            {localStorage.getItem("LANG") == 1
                                ? rowData["className"]
                                : rowData["className_en"]}
                        </Col>
                        <Col
                            lg={1}
                            md={1}
                            sm={1}
                            xs={12}
                            className="overflow-text-length"
                            title={rowData["countCard"]}
                        >
                            {rowData["countCard"]}
                        </Col>
                        <Col
                            lg={2}
                            md={2}
                            sm={2}
                            xs={12}
                            className="overflow-text-length"
                            title={rowData["salePrice"]}
                        >
                            {rowData["salePrice"]}
                        </Col>
                        <Col
                            lg={2}
                            md={2}
                            sm={2}
                            xs={12}
                            className="overflow-text-length"
                            title={rowData["buyPricePOS"]}
                        >
                            {rowData["buyPricePOS"]}
                        </Col>
                        <Col
                            lg={1}
                            md={1}
                            sm={1}
                            xs={12}
                            className="overflow-text-length"
                            title={rowData["netProfitPos"]}
                        >
                            {rowData["netProfitPos"]}
                        </Col>

                    </Row>
                );
            });
        }
        console.log("this.state.posData", this.state.posData.posName);

        return (
            <div className="view-modal-style">
                <div className="sidebar-header-view">
                    <Row>
                        <Col xs={10} lg={10} md={10} sm={10}>
                            <div className="p-0 main-color-1  sidebar-header-title">
                                {" "}
                                {Strings["Point profit disclosure"]} ({this.state.posData?.fname} {this.state.posData?.lname})
                            </div>
                        </Col>

                    </Row>
                </div>

                <div className="sidebar-body-view ">
                    <Row className="page-filter-view">
                        <Col md={6} xs={12} lg={6} sm={12}>
                            <AvForm
                                onValidSubmit={this.handleValidSubmit}
                                ref={(c) => (this.form = c)}
                            >
                                <Row className="filter-form">
                                    <Col md={6} xs={12} lg={6} sm={12} className="mb-1">
                                        <AvField
                                            name="dateFrom"
                                            type="date"
                                            label={Strings["From Date"]}
                                            value={this.state.dateFrom}
                                            onChange={this.handleInputChange}
                                        />
                                    </Col>
                                    <Col md={6} xs={12} lg={6} sm={12} className="mb-1">
                                        <AvField
                                            name="dateTo"
                                            type="date"
                                            label={Strings["To Date"]}
                                            value={this.state.dateTo}
                                            onChange={this.handleInputChange}
                                        />
                                    </Col>


                                </Row>
                            </AvForm>
                        </Col>
                        <Col
                            md={6}
                            xs={12}
                            lg={6}
                            sm={12}
                            className={
                                (localStorage.getItem("PERM_TYPE") == 5 ||
                                    this.props.permType == 5 ||
                                    localStorage.getItem("POS_MGR_EMP") == 1 ||
                                    localStorage.getItem("ACC_EMP") == 1 ||
                                    localStorage.getItem("OPERA_EMP") == 1) &&
                                    this.state.typesOps != 0
                                    ? "text-right position-parent-square"
                                    : "text-right"
                            }
                        >

                            <button
                                className="btn page-action-btn ml-1"
                                onClick={(event) => this.exportHandler(event)}
                            >
                                {Strings["Export"]}
                            </button>
                            <Col md={2} xs={12} lg={2} sm={12} className="mb-1 mr-auto p-0 ml-1 mt-2">
                                <Button
                                    variant="contained"
                                    className="refresh-action-btn   mb-md-0"
                                    onClick={this.handleRefresh}
                                    title={Strings["Refresh"]}
                                >
                                    <i className="flaticon-refresh reset-filter-btn"></i>
                                </Button>
                            </Col>
                            {(localStorage.getItem("PERM_TYPE") == 5 ||
                                this.props.permType == 5 ||
                                localStorage.getItem("POS_MGR_EMP") == 1 ||
                                localStorage.getItem("ACC_EMP") == 1 ||
                                localStorage.getItem("OPERA_EMP") == 1) &&
                                this.state.loading == 0 &&
                                this.state.data.length > 0 && (
                                    <Row
                                        className="d-flex align-items-end js-c ml-1 "


                                    >

                                        <Col
                                            xs={12}
                                            lg={6}
                                            md={12}
                                            sm={12}
                                            className="mt-3 algin-total-box financail-operation-report-summary-box-view"
                                        >

                                            {/* abood total */}
                                            {this.state.typesOps == 0 ? (
                                                <div>
                                                    <Row className="pos-financail-report-summary-row financail-operation-report-summary-lable">
                                                        <Col
                                                            md={8}
                                                            xs={12}
                                                            lg={8}
                                                            sm={12}
                                                            className="main-color-1 font-w-400 textRight"
                                                        >
                                                            {Strings["Total Sale Price"]}
                                                        </Col>
                                                        <Col
                                                            md={4}
                                                            xs={12}
                                                            lg={4}
                                                            sm={12}
                                                            className="text-center"
                                                        >
                                                            {this.state.cardsProfitTotal.buyPricePOS}
                                                        </Col>
                                                    </Row>
                                                    <Row className="pos-financail-report-summary-row financail-operation-report-summary-lable">
                                                        <Col
                                                            md={8}
                                                            xs={12}
                                                            lg={8}
                                                            sm={12}
                                                            className="main-color-1 font-w-400"
                                                        >
                                                            {Strings["Total Cost Prices"]}
                                                        </Col>
                                                        <Col
                                                            md={4}
                                                            xs={12}
                                                            lg={4}
                                                            sm={12}
                                                            className="text-center"
                                                        >
                                                            {this.state.cardsProfitTotal.salePrice}
                                                        </Col>
                                                    </Row>
                                                    <Row className="pos-financail-report-summary-row financail-operation-report-summary-lable">
                                                        <Col
                                                            md={8}
                                                            xs={12}
                                                            lg={8}
                                                            sm={12}
                                                            className="main-color-1 font-w-400"
                                                        >
                                                            {Strings["Total profits"]}
                                                        </Col>
                                                        <Col
                                                            md={4}
                                                            xs={12}
                                                            lg={4}
                                                            sm={12}
                                                            className="text-center"
                                                        >
                                                            {this.state.cardsProfitTotal.Profit}
                                                        </Col>
                                                    </Row>

                                                </div>
                                            ) : (
                                                <div>
                                                    <Row className="pos-financail-report-summary-row financail-operation-report-summary-lable">
                                                        <Col
                                                            md={8}
                                                            xs={12}
                                                            lg={8}
                                                            sm={12}
                                                            className="main-color-1 font-w-400"
                                                        >
                                                            {Strings["Total balance"]}
                                                        </Col>
                                                        <Col
                                                            md={4}
                                                            xs={12}
                                                            lg={4}
                                                            sm={12}
                                                            className="text-center"
                                                        >
                                                            {this.state.totalFilter}
                                                        </Col>
                                                    </Row>
                                                </div>
                                            )}
                                        </Col>
                                    </Row>
                                )}
                        </Col>
                    </Row>

                    {this.state.loading == 1 && (
                        <Row>
                            <Col
                                md={12}
                                xs={12}
                                lg={12}
                                sm={12}
                                style={{ marginTop: "15%" }}
                                className="text-center"
                            >
                                <div className="card-body">
                                    <div
                                        className="spinner-grow text-dark m-2 main-color-1"
                                        role="status"
                                    ></div>
                                    <div
                                        className="spinner-grow text-dark m-2 main-color-2"
                                        role="status"
                                    ></div>
                                    <div
                                        className="spinner-grow text-dark m-2 main-color-1"
                                        role="status"
                                    ></div>
                                    <div
                                        className="spinner-grow text-dark m-2 main-color-2"
                                        role="status"
                                    ></div>
                                    <div
                                        className="spinner-grow text-dark m-2 main-color-1"
                                        role="status"
                                    ></div>
                                    <div
                                        className="spinner-grow text-dark m-2 main-color-2"
                                        role="status"
                                    ></div>
                                </div>
                            </Col>
                        </Row>
                    )}

                    {this.state.loading == 0 && this.state.errorMsg != "" && (
                        <div className="text-center" style={{ marginTop: "15%" }}>
                            <img
                                alt="Logo"
                                src={toAbsoluteUrl(
                                    "/media/ezpay/EZPAY_LOGO_GRAY" + window.MAIN_IMAGE + ".png"
                                )}
                                className="img-fluid no-data-img"
                            />
                            <div className="no-data-text">{this.state.errorMsg}</div>
                        </div>
                    )}

                    {this.state.loading == 0 && this.state.data.length <= 0 && (
                        <div className="text-center" style={{ marginTop: "15%" }}>
                            <img
                                alt="Logo"
                                src={toAbsoluteUrl(
                                    "/media/ezpay/EZPAY_LOGO_GRAY" + window.MAIN_IMAGE + ".png"
                                )}
                                className="img-fluid no-data-img"
                            />
                            <div className="no-data-text">
                                {Strings["There is no data to display"]}
                            </div>
                        </div>
                    )}

                    {this.state.loading == 0 && this.state.data.length > 0 && (
                        <Row>
                            <div className="inv-cards-view width-100">
                                {/* abood header  */}
                                <Row className="table-header-row">
                                    <Col
                                        lg={3}
                                        md={3}
                                        sm={3}
                                        xs={12}
                                        className="overflow-text-length"
                                        title={Strings["Card Name"]}
                                    >
                                        {Strings["Card Name"]}
                                    </Col>
                                    <Col
                                        lg={1}
                                        md={1}
                                        sm={1}
                                        xs={12}
                                        className="overflow-text-length"
                                        title={Strings["Class #"]}
                                    >
                                        {Strings["Class #"]}
                                    </Col>
                                    <Col
                                        lg={2}
                                        md={2}
                                        sm={2}
                                        xs={12}
                                        className="overflow-text-length"
                                        title={Strings["Class Name"]}
                                    >
                                        {Strings["Class Name"]}
                                    </Col>


                                    <Col
                                        lg={1}
                                        md={1}
                                        sm={1}
                                        xs={12}
                                        className="overflow-text-length"
                                        title={Strings["Total Cards"]}
                                    >
                                        {Strings["Total Cards"]}
                                    </Col>
                                    <Col
                                        lg={2}
                                        md={2}
                                        sm={2}
                                        xs={12}
                                        className="overflow-text-length"
                                        title={Strings["Cost Value"]}
                                    >
                                        {Strings["Cost Value"]}
                                    </Col>
                                    <Col
                                        lg={2}
                                        md={2}
                                        sm={2}
                                        xs={12}
                                        className="overflow-text-length"
                                        title={Strings["Selling Price"]}
                                    >
                                        {Strings["Selling Price"]}
                                    </Col>
                                    <Col
                                        lg={1}
                                        md={1}
                                        sm={1}
                                        xs={12}
                                        className="overflow-text-length"
                                        title={Strings["Profit"]}
                                    >
                                        {Strings["Profit"]}
                                    </Col>


                                </Row>
                                {dataInfo}
                                {this.state.loading == 0 && this.state.data.length > 0 && (
                                    <Col md={12} xs={12} lg={12} sm={12}>
                                        <Row className="pagenation-view mt-3 mb-4">
                                            <Pagination
                                                activePage={this.state.activePage}
                                                itemsCountPerPage={this.state.limit}
                                                totalItemsCount={this.state.dataCount}
                                                pageRangeDisplayed={4}
                                                onChange={this.handlePageChange}
                                                prevPageText={
                                                    <i
                                                        className={
                                                            localStorage.getItem("LANG") == 1
                                                                ? "flaticon2-next"
                                                                : "flaticon2-back"
                                                        }
                                                    ></i>
                                                }
                                                nextPageText={
                                                    <i
                                                        className={
                                                            localStorage.getItem("LANG") == 1
                                                                ? "flaticon2-back"
                                                                : "flaticon2-next"
                                                        }
                                                    ></i>
                                                }
                                                hideFirstLastPages
                                                innerClass={
                                                    "pagination  pagination-rounded justify-content-end pagenation-view my-2"
                                                }
                                                itemClass={"page-item"}
                                                linkClass={"page-link"}
                                            />
                                        </Row>
                                    </Col>
                                )}
                            </div>
                        </Row>
                    )}
                </div>
            </div>
        );
    }
}
export default PointProfit;
